import { createContext, useContext, useEffect, useState } from "react";

import { apiCoberturaListado } from "../settings/apiConfig";
import { useRequest } from "./RequestContext";

export const CoberturaContext = createContext();

export const CoberturaProvider = (props) => {
    const { Get } = useRequest();

    const [listaCobertura, setListaCobertura] = useState([]);

    const handleClickObtenerCobertura = async () => {
        const response = await CGetCobertura();
        if (response.Code === 0) {
            setListaCobertura(response.Result);
        } else {
            setListaCobertura([]);
        }
    };

    const CGetCobertura = async () => {
        const payload = {
            url: apiCoberturaListado,
        };

        return await Get(payload);
    };

    useEffect(() => {
        handleClickObtenerCobertura();
        // eslint-disable-next-line
    }, []);

    return <CoberturaContext.Provider value={{ listaCobertura, handleClickObtenerCobertura }}>{props.children}</CoberturaContext.Provider>;
};

export const useCobertura = function () {
    return useContext(CoberturaContext);
};
